import React from "react";
import ReactDOM from "react-dom";
import MapSearchContainer from "./MapSearchContainer";
import "leaflet/dist/leaflet.css";

const rootElement = document.getElementById("map-search");

const initMapSearch = (trad) => {
  const rootElement = document.getElementById("map-search");
  if (!rootElement) return;

  const component = <MapSearchContainer translations={trad} />;

  const root = ReactDOM.createRoot(rootElement);
  root.render(component);
};

export default initMapSearch;
